import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'stripeMerchantAccount',
  initialState: null as string | null,
  reducers: {
    setStripeMerchantAccount(state, action: PayloadAction<string | null>) {
      return action.payload || null;
    },
  },
});

export const { setStripeMerchantAccount } = slice.actions;

export default slice.reducer;
